module.exports = __webpack_public_path__ + "img/cover-opet-infographic.bc7b20e2.jpg";